export const FETCH_MIPS_REPORT ="FETCH_MIPS_REPORT"
export const FETCH_MIPS_REPORT_SUCCESS = 'FETCH_MIPS_REPORT_SUCCESS'
export const FETCH_MIPS_REPORT_ERROR = 'FETCH_MIPS_REPORT_ERROR'